import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/BrandLeaderBoardSagas";

const MetricsFilter = () => {
  const dispatch = useDispatch();
  const { metrics, selectedMetrics } = useSelector((state) => state.BrandLeaderBoard);

  return (
    <MultiSelectDropdown
      options={metrics}
      selectedFilters={selectedMetrics}
      selectAll={false}
      enableOnly
      numberDisplayed={0}
      includeSelectAll
      defaultSelected={false}
      displayCheckedOnly
      haveOnSelectChange
      onSelectChange={(data) => dispatch(actionCreators.updateSelectedMetricsFilter(data))}
    />
  );
};

export default MetricsFilter;
